import type { ComponentType, SVGProps } from "react";
import type { IconWeight } from "@phosphor-icons/react/dist/lib/types";

/** Decorative icons in navigation, destination cards, and featured empty states. */
export type DestinationIconComponent = ComponentType<{
  className?: string;
  weight?: IconWeight;
  "aria-hidden"?: SVGProps<SVGSVGElement>["aria-hidden"];
}>;

export function DestinationIcon({
  icon: Icon,
  ...props
}: {
  icon: DestinationIconComponent;
  className?: string;
}) {
  return <Icon {...props} weight="duotone" aria-hidden="true" />;
}
